<template>
  <pt-video-review-table class="pt-video-review-table__withData" ref="table" :request-data="getDataList" :page-size="pageSize"
  :total-number="Number(totalNumber)" :table-data="tableData" :tableLabels="tableLabels" :status="status">
  <slot/>
  </pt-video-review-table>
</template>

<script>
import PtVideoReviewTable from './index'
export default {
  name: 'pt-video-review-table__withData',
  components: {
    'pt-video-review-table': PtVideoReviewTable
  },
  data () {
    return {
      pageSize: 20,
      totalNumber: 0,
      tableData: [],
      currentParams: {}
    }
  },
  props: {
    status: {
      type: String,
      required: true
    },
    tableLabels: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    // status (val, old) {
    //   this.$refs.table.reload()
    // }
  },
  methods: {
    buildFilterParams (page, params = {}) {
      console.log('============')
      if (Object.keys(params).length) {
        params.pageable['page'] = page
        params.pageable['size'] = this.pageSize
        return params
      } else {
        let example
        if (this.status === 'PUBLISHEDFALSE') {
          example = {
            type: 'VIDEO',
            published: false,
            status: 'APPROVED'
          }
        } else if (this.status === 'APPROVED') {
          example = {
            type: 'VIDEO',
            published: true
          }
        } else {
          example = {
            type: 'VIDEO',
            status: this.status
          }
        }
        return {
          example,
          pageable: { page: page, size: this.pageSize }
        }
      }
    },
    getDataList (page, next) {
      let data = this.buildFilterParams(page, this.currentParams)
      this.$store.dispatch('getPosterList', data).then(res => {
        next(res.data)
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        this.$emit('getAllSize', this.totalNumber)
      }).catch(err => {
        this.$refs.table.showReTry()
        this.$message.error(err)
      })
    },
    // 筛选数据的参数,不传默认为{}
    reload (params = {}) {
      this.currentParams = params
      this.$refs.table.reload()
    }
  }
}
</script>
